import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <path
    d="M10 8h6a1.001 1.001 0 0 0 0 -1.999h-6a1.001 1.001 0 0 0 0 1.999ZM8 12h8.001a1.001 1.001 0 0 0 0 -1.999H8a1.001 1.001 0 0 0 0 1.999Zm0 4h8.001a1.001 1.001 0 1 0 0 -2.001H8a1.001 1.001 0 1 0 0 2.001Zm12 -14.001H4A1.001 1.001 0 0 0 3 3v18a1.001 1.001 0 0 0 1.6 0.8l2.07 -1.549 2.059 1.549a1.001 1.001 0 0 0 1.2 0L12 20.25l2.07 1.549a1.001 1.001 0 0 0 1.2 0l2.059 -1.549 2.07 1.549A1.002 1.002 0 0 0 21 21V3a0.999 0.999 0 0 0 -1.001 -1.001Zm-0.999 17.001 -1.071 -0.801a0.999 0.999 0 0 0 -1.2 0L14.67 19.75 12.6 18.2a0.999 0.999 0 0 0 -1.2 0l-2.07 1.551 -2.059 -1.551a0.999 0.999 0 0 0 -1.2 0l-1.071 0.801v-15h14.001v15Z"
    fill={fill}
  />
);

export default Icon;
